<template>
  <div v-if="channelUrl" class="hub-telegram">
    <a :href="channelUrl" target="_blank" rel="noopener" class="hub-telegram__card">
      <span class="hub-telegram__icon">
        <TelegramLineIcon :size="34" color="#FFFFFF" />
      </span>
      <span class="hub-telegram__text">
        <span class="hub-telegram__title" v-html="getTitleBlock(page, 'telegram', 'title')"></span>
        <span class="hub-telegram__description" v-html="getTitleBlock(page, 'telegram', 'description')"></span>
      </span>
      <span class="hub-telegram__button">
        {{ getKeyValueListBlockValue(page, 'telegram-details', 'button') }}
        <span class="hub-telegram__button-dot">
          <ChevronRightLineIcon :size="16" color="#6171E4" />
        </span>
      </span>
    </a>
  </div>
</template>

<script>
import { textBlock } from '@/entities/text-block';
import { RESOURCES_HUB_TEXT_PAGE } from '@/features/agent-resources/config';
import { Env } from '@/shared/config/environment';
import { ChevronRightLineIcon, TelegramLineIcon } from '@/shared/ui/icons';

export default {
  mixins: [ textBlock ],
  components: { TelegramLineIcon, ChevronRightLineIcon },
  data() {
    return {
      page: RESOURCES_HUB_TEXT_PAGE,
      channelUrl: Env.telegram.agentsChannelUrl,
    };
  },
};
</script>

<style lang="scss" scoped>
.hub-telegram {
  max-width: 1328px;
  margin: 64px auto 0;
  padding: 0 24px;

  @media (max-width: 800px) {
    margin-top: 32px;
    padding: 0 16px;
  }

  &__card {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 20px 32px;
    padding: 28px 28px 28px 32px;
    border-radius: 28px;
    background: #FFFFFF;
    box-shadow: 0 16px 48px rgba(55, 58, 61, 0.10);
    color: #373A3D;
    text-decoration: none;

    @media (max-width: 800px) {
      padding: 24px;
    }
  }

  &__icon {
    flex: none;
    width: 72px;
    height: 72px;
    border-radius: 999px;
    background: #6171E4;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }

  &__text {
    flex: 1 1 320px;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  &__title {
    font-family: 'IBM Plex Sans', sans-serif;
    font-weight: 600;
    font-size: 26px;
    line-height: 32px;

    @media (max-width: 800px) {
      font-size: 22px;
      line-height: 28px;
    }
  }

  &__description {
    font-size: 17px;
    line-height: 25px;
    color: #494E53;
  }

  &__button {
    flex: none;
    display: inline-flex;
    align-items: center;
    gap: 12px;
    height: 54px;
    padding: 0 8px 0 24px;
    border-radius: 12px;
    background: #6171E4;
    color: #FFFFFF;
    font-family: 'IBM Plex Sans', sans-serif;
    font-weight: 600;
    font-size: 17px;
    transition: background-color 0.2s;

    @media (max-width: 800px) {
      flex: 1 1 100%;
      justify-content: space-between;
    }
  }

  &__card:hover &__button {
    background: #4555CC;
  }

  &__button-dot {
    width: 36px;
    height: 36px;
    border-radius: 999px;
    background: #FFFFFF;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
